<template>
  <div
    v-focus-visible
    class="app-container"
    :class="{ 'is-preview': galleryStore.isPreview }"
    @click.capture="globalClickHandler"
    @focus.capture="globalFocusHandler"
  >
    <!-- We don't need router links here as there is no nav but we
    do need router-view to enable in-component route guards -->
    <router-view />
    <div id="popups" role="dialog" aria-label="The popup is open." aria-modal="true"></div>
  </div>
</template>

<script>
import '@/styles/main.css';
import { mapStores } from 'pinia';
import { useGalleryStore } from '@/stores/gallery';

export default {
  computed: {
    ...mapStores(useGalleryStore),
  },

  created() {
    // Only set route data if the route has a gallery type
    if (this.$route.meta?.galleryType) {
      this.galleryStore.setRouteData({ $route: this.$route });
    }
  },
  methods: {
    // We don't want to allow for the preview to be used nefariously
    globalClickHandler(event) {
      if (this.galleryStore.isPreview) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    globalFocusHandler(event) {
      if (this.galleryStore.isPreview) {
        event.target.blur();
        event.preventDefault();
        event.stopPropagation();
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.is-preview {
  pointer-events: none;
}
</style>
